/*! Auric product page — gallery, zoom, variant selection, sticky ATC, size guide, quantity */
(function () {
  'use strict';

  var form = document.querySelector('.product-form');
  if (!form) return;

  var productInfo = document.querySelector('[data-product-info]');
  var gallery = document.querySelector('[data-product-gallery]');

  /* ---------- Gallery thumbnails ---------- */
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-gallery-thumb');
        slides.forEach(function (s) { s.style.display = s.getAttribute('data-gallery-slide') === idx ? 'block' : 'none'; });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    /* Zoom (click to toggle a larger view) */
    var zoomTrigger = gallery.querySelector('[data-zoom-trigger]');
    if (zoomTrigger) {
      zoomTrigger.addEventListener('click', function () {
        var activeImg = gallery.querySelector('[data-gallery-slide]:not([style*="display: none"]) img[data-zoom-src]');
        if (!activeImg) return;
        var overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;z-index:90;background:rgba(0,0,0,0.9);display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
        var img = document.createElement('img');
        img.src = activeImg.getAttribute('data-zoom-src');
        img.style.cssText = 'max-width:92vw;max-height:92vh;object-fit:contain;';
        overlay.appendChild(img);
        overlay.addEventListener('click', function () { overlay.remove(); });
        document.body.appendChild(overlay);
      });
    }
  }

  /* ---------- Variant selection ---------- */
  var optionInputs = form.querySelectorAll('[data-option-input]');
  var variantIdInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add-to-cart-btn]');
  var atcLabel = form.querySelector('[data-atc-label]');
  var priceEl = document.querySelector('[data-product-price]');

  var productJsonEl = document.getElementById('ProductJson-' + (window.AuricProductId || ''));
  var productData = window.AuricProductData || null;

  function getSelectedOptions() {
    var selected = [];
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('[data-option-input]:checked');
      selected.push(checked ? checked.value : null);
    });
    return selected;
  }

  function findMatchingVariant(options) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    });
  }

  var isComingSoon = !!(productData && productData.tags && productData.tags.indexOf('coming-soon') !== -1);

  function updateUIForVariant(variant) {
    if (!variant) return;
    variantIdInput.value = variant.id;
    if (priceEl) {
      priceEl.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
        ? '<span class="product-card__price--compare">' + formatMoney(variant.compare_at_price) + '</span> <span class="product-card__price--sale">' + formatMoney(variant.price) + '</span>'
        : formatMoney(variant.price);
    }
    if (addBtn) { addBtn.disabled = isComingSoon || !variant.available; }
    if (atcLabel) {
      atcLabel.textContent = isComingSoon ? 'Coming Soon' : variant.available === false ? (window.AuricStrings && window.AuricStrings.soldOut || 'Sold Out') : (window.AuricStrings && window.AuricStrings.addToCart || 'Add to Bag') + ' · ' + formatMoney(variant.price);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.closest('.variant-option');
      group.querySelectorAll('label').forEach(function (l) { l.classList.remove('is-selected'); });
      input.closest('label').classList.add('is-selected');
      var valueDisplay = group.querySelector('[data-selected-value]');
      if (valueDisplay) valueDisplay.textContent = input.value;

      var options = getSelectedOptions();
      var variant = findMatchingVariant(options);
      if (variant) updateUIForVariant(variant);

      /* Sync URL for shareable variant links */
      if (variant && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    });
  });

  /* ---------- Quantity stepper on product form ---------- */
  var qtyInput = form.querySelector('[data-qty-input]');
  var qtyInc = form.querySelector('[data-qty-increase]');
  var qtyDec = form.querySelector('[data-qty-decrease]');
  if (qtyInc) qtyInc.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
  if (qtyDec) qtyDec.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });

  /* ---------- Size guide modal ---------- */
  var sizeGuideModal = document.getElementById('SizeGuideModal');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-size-guide-open]') && sizeGuideModal) { sizeGuideModal.classList.add('is-open'); sizeGuideModal.removeAttribute('aria-hidden'); }
    if (e.target.closest('[data-size-guide-close]') && sizeGuideModal) { sizeGuideModal.classList.remove('is-open'); sizeGuideModal.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------- Sticky add-to-cart visibility ---------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  if (stickyAtc && productInfo) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    var addBtnEl = productInfo.querySelector('[data-add-to-cart-btn]');
    if (addBtnEl) observer.observe(addBtnEl);
  }
})();
